type PageStateProps = {
  title: string;
  detail: string;
  action?: () => void;
  actionLabel?: string;
};

export function PageState({ title, detail, action, actionLabel = "Try again" }: PageStateProps) {
  return (
    <section className="unsub-page-state" role={action ? "alert" : "status"}>
      <div className="unsub-page-state-mark" aria-hidden="true">U</div>
      <h1>{title}</h1>
      <p>{detail}</p>
      {action ? <button className="unsub-button" type="button" onClick={action}>{actionLabel}</button> : null}
    </section>
  );
}
